define('modules/domain_listing/views/listing_item',['require','exports','module','base/itemview','ldsh!../templates/listing_item'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/listing_item"),
    tagName: "div",
    className: "ed-box-item ed-box-item-dom",
    triggers: {
      "click .js-edit": "domain:edit",
      "click .js-delete": "domain:delete",
      "click .js-validate": "domain:validate"
    },
    onRender: function() {
      this.$el.i18n();
    }
  });

});

